class ProductDetailTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('.pdt-tab-btn'));
    this.tabPanels = Array.from(this.querySelectorAll('.pdt-tabpanel'));

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => this.switchTab(event.currentTarget));
    });
  }

  switchTab(selectedButton) {
    const targetId = selectedButton.getAttribute('data-tab-target');

    this.tabButtons.forEach((button) => {
      const isSelected = button === selectedButton;
      button.classList.toggle('active', isSelected);
      button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    this.tabPanels.forEach((panel) => {
      panel.classList.toggle('active', panel.id === targetId);
    });
  }
}

if (!customElements.get('product-detail-tabs')) {
  customElements.define('product-detail-tabs', ProductDetailTabs);
}